module.exports = __webpack_public_path__ + "static/media/aluminio-fleje.8c8624e9.jpg";